import { apiFetch } from '$lib/api/helpers';
import type { RoomProductRequest, RoomProductResponse } from '$lib/types/product';

const PATH = '/room_products/';

export async function fetchRoomProducts() {
	return apiFetch<Array<RoomProductResponse>>(PATH);
}

export async function fetchRoomProductsByRoom(roomId: number) {
	return apiFetch<Array<RoomProductResponse>>(`${PATH}by_room/?room_id=${roomId}`);
}

export async function createRoomProduct(roomProductRequest: RoomProductRequest) {
	return apiFetch<RoomProductResponse>(PATH, {
		method: 'POST',
		body: JSON.stringify(roomProductRequest)
	});
}
